/* eslint-disable class-methods-use-this */
import {
    RiAlarmWarningLine, RiArrowDownDoubleLine, RiErrorWarningLine, RiFlagFill,
} from "@remixicon/react";
import React from "react";
import { DashboardGroupBy, TicketPriority } from "../../../__generated__/api";
import TicketItem from "../ticket-item";
import { GROUP_REGISTRY, GroupBy, GroupDescriptor } from "./base";

const PRIORITY_ICONS: Record<string, GroupDescriptor> = {
    [TicketPriority.Critical]: {
        id: TicketPriority.Critical,
        icon: (
            <div className="group-letter-icon group-letter-icon-critical">
                <RiFlagFill />
            </div>
        ),
        title: "Critical",
    },
    [TicketPriority.High]: {
        id: TicketPriority.High,
        icon: (
            <div className="group-letter-icon group-letter-icon-high">
                <RiFlagFill />
            </div>
        ),
        title: "High",
    },

    [TicketPriority.Medium]: {
        id: TicketPriority.Medium,
        icon: (
            <div className="group-letter-icon group-letter-icon-medium">
                <RiFlagFill />
            </div>
        ),
        title: "Medium",
    },
    [TicketPriority.Low]: {
        id: TicketPriority.Low,
        icon: (
            <div className="group-letter-icon group-letter-icon-low">
                <RiFlagFill />
            </div>
        ),
        title: "Low",
    },
};

export default class GroupByPriority extends GroupBy {
    public static shouldCreate(groupBy: DashboardGroupBy): boolean {
        return groupBy === DashboardGroupBy.Priority;
    }

    public getGroup(id: string): GroupDescriptor {
        return PRIORITY_ICONS[id];
    }

    public getGroupId(ticket: TicketItem): string | undefined {
        return ticket.priority;
    }
}

GROUP_REGISTRY.register(GroupByPriority);
